import { CheckBoxProps, CheckBoxWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { DefaultBodyCellStyle } from '../../../app/spaces/ListView/StyledCellWrapper';
import { CheckboxState } from '../../../common/components/checkboxes/CheckboxState';
import { GroupsGridCheckboxCellData, GroupsGridColumnKeys, GroupsGridGroupCellData,GroupsGridRow } from './GroupsGrid';

export const GROUPS_GRID_ROW_CHECKBOX_TEST_ID = 'group-membership-groups-grid-row-';
export const GROUPS_GRID_ROW_GROUPNAME_TEST_ID = 'group-membership-groups-grid-row-groupname-';

export class GroupsGridCellFormatter extends React.PureComponent<BodyCell.Props, object> {
  public constructor(props: BodyCell.Props) {
    super(props);
  }

  private renderCheckboxCell(): JSX.Element {
    const checkBoxCellData = this.props.row.data[GroupsGridColumnKeys.Checkbox] as GroupsGridCheckboxCellData;
    const checkboxChecked = checkBoxCellData.checkboxState === CheckboxState.checked;
    const checkboxMixedState = checkBoxCellData.checkboxState === CheckboxState.mixed;
    const checkBoxProps: CheckBoxProps = {
      checked: checkboxChecked,
      handleChange: () => { checkBoxCellData.onCheckboxChanged(); },
      indeterminate: checkboxMixedState,
      testId: GROUPS_GRID_ROW_CHECKBOX_TEST_ID + this.props.rowIdx,
      disabled: !checkBoxCellData.isCheckboxEnabled
    };

    return <div>
      <CheckBoxWidget {...checkBoxProps}/>
    </div>;
  }

  private tooltipContent(): JSX.Element {
    const groupCellData = this.props.row.data[GroupsGridColumnKeys.GroupName] as GroupsGridGroupCellData;
    const text = groupCellData.groupName + ' (' + groupCellData.domainName + ')';
    return <span>{text}</span>;
  }

  private renderGroupNameCellData(): JSX.Element {
    const groupCellData = this.props.row.data[GroupsGridColumnKeys.GroupName] as GroupsGridGroupCellData;
    const GroupName = groupCellData.groupName;
    return (
      <div className={DefaultBodyCellStyle}>
        <Tooltip
          getContent={() => { return this.tooltipContent();}}
          position={TooltipPosition.Bottom}
        >
          <span
            tabIndex={-1}
            data-tb-test-id={GROUPS_GRID_ROW_GROUPNAME_TEST_ID + this.props.rowIdx}
          >
            {GroupName}
          </span>
        </Tooltip>
      </div>
    );
  }

  private renderRowWithData(): JSX.Element {
    const columnKey = this.props.col.dataKey as GroupsGridColumnKeys;

    switch(columnKey) {
      case GroupsGridColumnKeys.Checkbox:
        return this.renderCheckboxCell();
      case GroupsGridColumnKeys.GroupName:
        return this.renderGroupNameCellData();
      default:
        return <React.Fragment />;
    }
  }

  public render(): JSX.Element {
    const row: GroupsGridRow = this.props.row as GroupsGridRow;
    return this.renderRowWithData();
  }
}

const GroupsGridCellFormatterFactory = React.createFactory(GroupsGridCellFormatter);

export { GroupsGridCellFormatterFactory };
